import React, { useState, useEffect } from 'react';
import * as SecureStore from 'expo-secure-store';

import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import Header from '../components/Header.tsx';
import Footer from '../components/Footer.tsx';
import { getUserToken } from '../utils/helpers.js';

// Hook personalizado para o perfil do usuário
function useUserProfile() {
  const [profile, setProfile] = useState<any>(null);
  const [plan, setPlan] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getUserToken();
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    // console.log("🔑 Token:", token);
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${baseUrl}/api/auth/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error('Failed to fetch profile');

        const data = await res.json();
        setProfile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
        setProfile(null);
      }
    };

    const fetchCurrentPlan = async () => {
      // console.log("Entrou ou nao ")
      try {
        const res = await fetch(`${baseUrl}/api/userPlans/current`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log("Ver o que é pego",res);
        if (!res.ok) throw new Error('Failed to fetch plan');

        const data = await res.json();
        // console.log('Planos ', data);

        setPlan(data);
      } catch (error) {
        console.error('Error fetching plan:', error);
        setPlan(null);
      }
    };

    Promise.all([fetchProfile(), fetchCurrentPlan()]).finally(() => setLoading(false));
  }, []);

  return { profile, setProfile, plan, loading };
}

export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, setProfile, plan, loading } = useUserProfile();
  const [activeTab, setActiveTab] = useState<'personal' | 'plan' | 'history' | 'dashboard'>('personal');
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error' | ''>('');



  // Redirecionar se não estiver logado
  // useEffect(() => {
  //   if (!getUserToken()) {
  //     navigate('/login', { replace: true });
  //   }
  // }, [navigate]);

  const handleLogout = () => {
    Cookies.remove('token');
    localStorage.removeItem('userEmail');
    navigate('/login', { replace: true });
  };

  // Redirecionar para dashboard quando a tab for alterada
  useEffect(() => {
    if (activeTab === 'dashboard') {
      navigate('/dashboard');
    }
  }, [activeTab, navigate]);

  const handleChange = (field: string, value: string) => {
    setProfile((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!profile?.id) return;

    setIsSaving(true);
    const token = getUserToken();
    const baseUrl = process.env.REACT_APP_BASE_API_URL;

    try {
      const res = await fetch(`${baseUrl}/api/users/${profile.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          first_name: profile.first_name,
          last_name: profile.last_name,
          phone: profile.phone,
        }),
      });

      if (!res.ok) throw new Error('Failed to update profile');

      setMessage('Profile updated successfully.');
      setMessageType('success');
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating profile:', error);
      setMessage('Failed to update profile.');
      setMessageType('error');
    } finally {
      setIsSaving(false);
      // Remove message after 3 seconds
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 3000);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="text-center my-5" style={{ marginTop: '100px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading profile...</p>
        </div>
        <Footer />
      </>
    );
  }

  const primaryColor = '#22C55E';
  const borderColor = '#444';
  const backgroundColor = '#111';

  return (
    <>
      <Header />
      <div style={{
        display: 'flex',
        padding: '40px',
        gap: '40px',
        minHeight: '80vh',
        marginTop: '80px',
        backgroundColor: backgroundColor,
        color: '#fff'
      }}>
        {/* Sidebar */}
        <div style={{ width: '250px', textAlign: 'center' }}>
          <div style={{
            border: `1px solid ${borderColor}`,
            borderRadius: '6px',
            padding: '20px',
            backgroundColor: '#1a1a1a'
          }}>
            <div style={{ fontSize: '50px', color: primaryColor }}>👤</div>
            <h4 style={{ margin: '10px 0 5px', color: '#fff' }}>
              {profile?.first_name} {profile?.last_name}
            </h4>
            <p style={{ fontSize: '14px', color: '#aaa' }}>{profile?.email}</p>
          </div>

          <div style={{
            marginTop: '30px',
            border: `1px solid ${borderColor}`,
            borderRadius: '6px',
            overflow: 'hidden',
            backgroundColor: '#1a1a1a'
          }}>


            {['personal', 'plan', 'history', 'dashboard'].map((tab) => (
              <div
                key={tab}
                onClick={() => {
                  if (tab === 'dashboard') {
                    // Redireciona para dashboard
                    navigate('/dashboard');
                  } else {
                    // Muda o tab localmente
                    setActiveTab(tab as any);
                  }
                }}
                style={{
                  padding: '12px',
                  cursor: 'pointer',
                  backgroundColor: activeTab === tab ? primaryColor : 'transparent',
                  color: activeTab === tab ? '#fff' : '#ccc',
                  borderBottom: `1px solid ${borderColor}`,
                  fontWeight: activeTab === tab ? 'bold' : 'normal',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = '#333';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {{
                  personal: 'Personal Data',
                  plan: 'My Plan',
                  history: 'Plan History',
                  dashboard: 'Dashboard',
                }[tab]}
              </div>
            ))}
            {/* {['personal', 'plan', 'history', 'dashboard'].map((tab) => (
              <div
                key={tab}
                onClick={() => setActiveTab(tab as any)}
                style={{
                  padding: '12px',
                  cursor: 'pointer',
                  backgroundColor: activeTab === tab ? primaryColor : 'transparent',
                  color: activeTab === tab ? '#fff' : '#ccc',
                  borderBottom: `1px solid ${borderColor}`,
                  fontWeight: activeTab === tab ? 'bold' : 'normal',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = '#333';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {{
                  personal: 'Personal Data',
                  plan: 'My Plan',
                  history: 'Plan History',
                  dashboard: 'Dashboard',
                }[tab]}
              </div>
            ))} */}


          </div>
        </div>

        {/* Content */}
        <div style={{ flexGrow: 1 }}>
          {activeTab === 'personal' && (
            <div style={{
              border: `1px solid ${borderColor}`,
              padding: '30px',
              borderRadius: '6px',
              backgroundColor: '#1a1a1a'
            }}>
              <h3 style={{ color: primaryColor, marginBottom: '20px' }}>Personal Data</h3>

              <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ color: '#ccc', marginBottom: '5px', display: 'block' }}>First Name</label>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#333',
                      color: '#fff',
                      border: `1px solid ${borderColor}`,
                      padding: '10px'
                    }}
                    value={profile?.first_name || ''}
                    disabled={!isEditing}
                    onChange={(e) => handleChange('first_name', e.target.value)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ color: '#ccc', marginBottom: '5px', display: 'block' }}>Last Name</label>
                  <input
                    className="form-control"
                    style={{
                      backgroundColor: '#333',
                      color: '#fff',
                      border: `1px solid ${borderColor}`,
                      padding: '10px'
                    }}
                    value={profile?.last_name || ''}
                    disabled={!isEditing}
                    onChange={(e) => handleChange('last_name', e.target.value)}
                  />
                </div>
              </div>

              <div style={{ marginTop: '20px' }}>
                <label style={{ color: '#ccc', marginBottom: '5px', display: 'block' }}>Email</label>
                <input
                  className="form-control"
                  style={{
                    backgroundColor: '#555',
                    color: '#999',
                    border: `1px solid ${borderColor}`,
                    padding: '10px'
                  }}
                  value={profile?.email || ''}
                  disabled
                  readOnly
                />
              </div>

              <div style={{ marginTop: '20px' }}>
                <label style={{ color: '#ccc', marginBottom: '5px', display: 'block' }}>Phone</label>
                <input
                  className="form-control"
                  style={{
                    backgroundColor: '#333',
                    color: '#fff',
                    border: `1px solid ${borderColor}`,
                    padding: '10px'
                  }}
                  value={profile?.phone || ''}
                  disabled={!isEditing}
                  onChange={(e) => handleChange('phone', e.target.value)}
                />
              </div>

              {message && (
                <div
                  style={{
                    marginTop: '20px',
                    padding: '10px',
                    borderRadius: '4px',
                    color: messageType === 'success' ? '#22C55E' : '#EF4444',
                    fontWeight: 'bold',
                    backgroundColor: messageType === 'success' ? '#22C55E20' : '#EF444420',
                  }}
                >
                  {message}
                </div>
              )}

              <div style={{ marginTop: '30px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                {!isEditing ? (
                  <button
                    onClick={() => setIsEditing(true)}
                    style={{
                      background: primaryColor,
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Edit Profile
                  </button>
                ) : (
                  <>
                    <button
                      onClick={handleSave}
                      disabled={isSaving}
                      style={{
                        background: primaryColor,
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '4px',
                        cursor: isSaving ? 'not-allowed' : 'pointer',
                        opacity: isSaving ? 0.6 : 1
                      }}
                    >
                      {isSaving ? 'Saving...' : 'Save Changes'}
                    </button>
                    <button
                      onClick={() => {
                        setIsEditing(false);
                        setMessage('');
                      }}
                      style={{
                        background: '#555',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Cancel
                    </button>
                  </>
                )}

                <button
                  onClick={handleLogout}
                  style={{
                    background: '#EF4444',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    marginLeft: 'auto',
                    cursor: 'pointer'
                  }}
                >
                  Logout
                </button>
              </div>
            </div>
          )}

          {activeTab === 'plan' && plan && (
            <div style={{
              border: `1px solid ${borderColor}`,
              padding: '30px',
              borderRadius: '6px',
              backgroundColor: '#1a1a1a'
            }}>
              <h3 style={{ color: primaryColor, marginBottom: '20px' }}>My Plan</h3>
              <table style={{ width: '100%', marginTop: '20px', color: '#ccc', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr style={{ borderBottom: `1px solid ${borderColor}` }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>Plan</td>
                    <td style={{ padding: '10px' }}>{plan.plan?.name ?? 'N/A'}</td>
                  </tr>
                  <tr style={{ borderBottom: `1px solid ${borderColor}` }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>Price</td>
                    <td style={{ padding: '10px' }}>{plan.plan?.price === 0 ? 'Free' : `$${plan.plan?.price}`}</td>
                  </tr>
                  <tr style={{ borderBottom: `1px solid ${borderColor}` }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>Activated</td>
                    <td style={{ padding: '10px' }}>{new Date(plan.planStartDate).toLocaleDateString()}</td>
                  </tr>
                  <tr style={{ borderBottom: `1px solid ${borderColor}` }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>Expires</td>
                    <td style={{ padding: '10px' }}>{new Date(plan.planEndDate).toLocaleDateString()}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>Status</td>
                    <td style={{ padding: '10px' }}>
                      <span style={{
                        color: plan.isActive ? '#22C55E' : '#EF4444',
                        fontWeight: 'bold'
                      }}>
                        {plan.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              {plan.plan?.details && plan.plan.details.length > 0 && (
                <div style={{ marginTop: '30px' }}>
                  <h4 style={{ color: primaryColor, marginBottom: '15px' }}>Features</h4>
                  <ul style={{ color: '#aaa', paddingLeft: '20px' }}>
                    {plan.plan.details.map((detail: any, index: number) => (
                      <li key={index} style={{ marginBottom: '8px' }}>{detail.description}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          {activeTab === 'history' && (
            <div style={{
              border: `1px solid ${borderColor}`,
              padding: '30px',
              borderRadius: '6px',
              backgroundColor: '#1a1a1a'
            }}>
              <h3 style={{ color: primaryColor, marginBottom: '20px' }}>Plan History</h3>
              <p style={{ color: '#aaa' }}>No history available.</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}